__turbopack_context__.v({
  "actions": "ActionPlanTaskListCard-module__VBTb_q__actions",
  "card": "ActionPlanTaskListCard-module__VBTb_q__card",
  "chooser": "ActionPlanTaskListCard-module__VBTb_q__chooser",
  "chooserBtn": "ActionPlanTaskListCard-module__VBTb_q__chooserBtn",
  "filters": "ActionPlanTaskListCard-module__VBTb_q__filters",
  "groupChip": "ActionPlanTaskListCard-module__VBTb_q__groupChip",
  "groupLate": "ActionPlanTaskListCard-module__VBTb_q__groupLate",
  "groups": "ActionPlanTaskListCard-module__VBTb_q__groups",
  "late": "ActionPlanTaskListCard-module__VBTb_q__late",
  "meta": "ActionPlanTaskListCard-module__VBTb_q__meta",
  "pager": "ActionPlanTaskListCard-module__VBTb_q__pager",
  "pagerInfo": "ActionPlanTaskListCard-module__VBTb_q__pagerInfo",
  "row": "ActionPlanTaskListCard-module__VBTb_q__row",
  "rowTop": "ActionPlanTaskListCard-module__VBTb_q__rowTop",
  "tags": "ActionPlanTaskListCard-module__VBTb_q__tags",
  "title": "ActionPlanTaskListCard-module__VBTb_q__title",
});
